// noinspection JSUnusedGlobalSymbols

import router from "@/router";
// import Vuex from "vuex";
import Clipboard from "clipboard";
import {isLogin} from "@/utils/auth";
import {DeviceUtil} from "@/utils/deviceUtil";

let fileServer = null;

// let fileServer = "https://bbtshop.top/api/";

export function setFileServer(fileServer_new) {
  fileServer = fileServer_new;
}

const isProd = process.env.NODE_ENV === 'production'

/**
 * 全局实例方法和变量
 * (
 * vue的js中          可以this.getDictMapAwait('EnumBigGameType')来使用
 * vue的<template/>中 可以getDictMapAwait('EnumBigGameType')来使用
 * )
 */
const mixin = {
  computed: {
    ...Vuex.mapGetters([
      "paramMapAll",
      "siteTitle",
      "popPicInfo",
      "currency",
      "language",
      "country",
      "countryList",
      "systemVersion",
      "userLevel",
      "userInfo",
      "userMoney",
      "userCart",
      "userCartItems",
      "userCartTotalPrice",
      "serviceTime",
      "userCartItemCount"
      // 'noticeNum',
    ]),
    getInviteUrl() {
      let host =
        this.paramMapAll["FRONT_DOMAIN"] ||
        window.location.protocol + "//" + window.location.host;
      return (host + "m/register?codeNumber=" + this.userInfo.code).replace(
        /\/\/register/g,
        "/register"
      );
    },
    sellerSiteAddress() {
      if (location.host.startsWith("www.")) {                       // www.aa.com 域名
        return location.origin.replace("www.", "seller.");
      } else if (this.paramMapAll["SELLER_DOMAIN"]) {
        return this.paramMapAll["SELLER_DOMAIN"]
      } else if (location.host.includes(':8025')) {
        return location.origin.replace(':8025', ':8026')
      } // 非ip域名
      else if (/[^0-9.:]/.test(location.host) && location.host.split(".").length >= 2) {     // aa.com 顶级域名 或二级域名
        return `${location.origin.split('://')[0]}://seller.${location.host.split('.').slice(-2).join('.')}`
      } else if (location.host.includes(":1616")) {                  // 本地环境
        return location.origin.replace(":1616", ":8091");
      } else if (location.host.includes(":8093")) {                 // 测试环境
        return location.origin.replace(":8093", process.env.NODE_ENV === 'production' ? ":8094" : ":8097");
      } else {
        return location.origin + ":1717";
      }
    }
  },
  data() {
    return {
      isProd,
      showSearch: true,
      isTop: true,
      isBottom: false,
      isMobile: DeviceUtil.isMobile()
    };
  },
  created() {
  },
  mounted() {
    window.addEventListener("scroll", this.scrollscroll);
  },
  filters: {
    // 可直接 <div>createTime|toTime</div>
    toTime(dateTime) {
      return (
        dateTime && typeof dateTime === "string" && dateTime.substring(11, 16)
      ); //dateTime总共19位
    },
    toDatetime(dateTime) {
      return (
        dateTime && typeof dateTime === "string" && dateTime.substring(5, 16)
      ); //dateTime总共19位
    },
    toDate(dateTime) {
      return dateTime && typeof dateTime === 'string' && dateTime.split(" ")[0]
    },
    toTime_hms(dateTime) {
      return dateTime && typeof dateTime === "string" && dateTime.split(" ")[1];
    },
    filterPhone(value) {
      return value.replace(/^(\d{3,})\d{4}(\d{3,})$/, "$1****$2");
    },
    filterCard(value) {
      return value.length >= 10
        ? value.replace(/^(.{5}).+(.{5})$/, "$1*******$2")
        : value;
    },
    showPrice(price) {
      return price > 10000 ? price / 10000 + "w" : price;
    },
    filterVolume(number) {
      if (number > 100000000) {
        return (number / 100000000).toFixed(2) + "亿";
      } else if (number > 10000) {
        return (number / 10000).toFixed(2) + "万";
      }
      return number;
    }
  },
  methods: {
    //如果取不到多语言,就默认取英语
    $tt(messageCode, params, defaultStr) {
      if (!messageCode) {
        return messageCode;
      }
      let messageWith = null;
      let messageOri = null;
      if (messageCode.includes("message.")) {
        messageWith = "message." + messageCode;
        messageOri = messageCode;
      } else {
        messageWith = messageCode;
        messageOri = messageCode.replace("message.", "");
      }
      // debugger
      let searchResult = this.$t(messageWith, params);
      //没找到返回原key
      if (!searchResult || searchResult === messageWith) {
        return defaultStr || messageOri || "";
      }
      //找到了
      else {
        return searchResult;
      }
    },
    async getBanners(type) {
      return (await this.$get(`/banner/${type}/list`)).data || [];
    },
    async getPoster(code) {
      return (await this.$get(`/poster/${code}/info`)).data;
    },
    async getPosters(params) {
      return (await this.$get(`/poster/list`, {params})).data || [];
    },
    onCopy() {
      this.$toast.success(this.$t("Copy_Success"));
    },
    isEmpty(o) {
      return (
        null == o ||
        typeof o === "undefined" ||
        o === "undefined" ||
        o.length <= 0
      );
    },
    scrollscroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条距离顶部的距离
      this.isTop = scrollTop === 0;
      // this.showSearch = scrollTop <10 || scrollTop > 100
    },
    //给字符串中间三分一加*号
    starString(str) {
      if (str == null) {
        return str;
      }
      return (
        str.substring(0, str.length / 3) +
        "***" +
        str.substring(str.length - str.length / 3 + 1, str.length)
      );
    },
    goto(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push({path});
      }
    },
    jump(url) {
      console.log("jump url", url);
      if (url) {
        if (url.indexOf("http") >= 0) {
          let fontUrl = this.paramMapAll["FRONT_DOMAIN"];
          if (url.indexOf(fontUrl) >= 0) {
            //站内地址 直接用路由跳转避免多余的页面刷新
            this.$router.push({path: url.replace(fontUrl, "/")});
          } else {
            //站外地址
            location.href = url;
          }
        } else if (url.indexOf("#method#") >= 0) {
          //执行方法
          this[url.split("#method#")[1]]();
        } else {
          //站内地址
          this.$router.push({path: url});
        }
      }
    },
    //异步取字典(只返回指针(指针初始为空,等请求返回即可有数据))
    getDictMap(classname) {
      // this.$store.dispatch('getDictEnum', classname)
      return this.$store.state.common.dictEnumMapAll[classname];
    },
    //
    // async getParamValue(code) {
    //   let paramObj = await this.$store.dispatch('getParam', code);
    //   return paramObj && paramObj.value
    // },
    /**
     * ES6: base64解码
     */
    decodeBase64Content: function (base64Content) {
      if (!base64Content) return null;
      let commonContent = base64Content.replace(/\s/g, "+");
      commonContent = Buffer.from(commonContent, "base64").toString();
      return commonContent;
    },
    /**
     * 验证特殊字符
     */
    checkName(username) {
      let regEn = /[`~!@#$%^&*()_+<>?:"{},./;'[\]]/im,
        regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
      return !(regEn.test(username) || regCn.test(username));

    },
    sortByProperty(array, key) {
      return array.sort(function (a, b) {
        let x = a[key];
        let y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    /**
     * 获取本地ip
     */
    getLocationIP(onNewIP) {
      //  onNewIp - your listener function for new IPs
      //compatibility for firefox and chrome
      let myPeerConnection =
        window.RTCPeerConnection ||
        window.mozRTCPeerConnection ||
        window.webkitRTCPeerConnection;
      let pc = new myPeerConnection({
          iceServers: []
        }),
        noop = function () {
        },
        localIPs = {},
        ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

      function iterateIP(ip) {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
      }

      //create a bogus data channel
      pc.createDataChannel("");

      // create offer and set local description
      pc.createOffer()
        .then(function (sdp) {
          sdp.sdp.split("\n").forEach(function (line) {
            if (line.indexOf("candidate") < 0) return;
            line.match(ipRegex).forEach(iterateIP);
          });

          pc.setLocalDescription(sdp, noop, noop);
        })
        .catch(function () {
          // An error occurred, so handle the failure to connect
        });

      //sten for candidate events
      pc.onicecandidate = function (ice) {
        if (
          !ice ||
          !ice.candidate ||
          !ice.candidate.candidate ||
          !ice.candidate.candidate.match(ipRegex)
        )
          return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    },
    // 获取验证码
    getVerifyCode() {
      return (
        "/api/common/getCaptcha?t=" + Math.random()
      );
    },
    getFileViewUrl(file) {
      return file && file.replace(/{host}/g, fileServer);
    },

    getLogo() {
      return this.getFileViewUrl(this.paramMapAll['SITE_LOGO'] || '/logo.png')
    },
    getLogo2() {
      return this.getFileViewUrl(this.paramMapAll['SITE_LOGO2'] || '/logo_dark.png')
    },
    copyText(e, text) {
      const clipboard = new Clipboard(e.target, {text: () => text})
      clipboard.on('success', () => {
        this.$notify({type: 'success', message: this.$t('copy_success')});
        // 释放内存
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        // 不支持复制
        this.$notify({type: 'danger', message: 'replication fail!'});
        // 释放内存
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.onClick(e)
    },
    getMonthFirstDay() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      return `${year}-${month > 10 ? month : "0" + month}-01`;
    },
    getBeforeDate(num, time) {
      let n = num;
      let d = "";
      if (time) {
        d = new Date(time);
      } else {
        d = new Date();
      }
      let year = d.getFullYear();
      let mon = d.getMonth() + 1;
      let day = d.getDate();
      if (day <= n) {
        if (mon > 1) {
          mon = mon - 1;
        } else {
          year = year - 1;
          mon = 12;
        }
      }
      d.setDate(d.getDate() - n);
      year = d.getFullYear();
      mon = d.getMonth() + 1;
      day = d.getDate();
      return `${year}-${mon >= 10 ? mon : "0" + mon}-${
        day >= 10 ? day : "0" + day
      }`;
    },
    getToday() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      return `${year}-${month >= 10 ? month : "0" + month}-${
        day >= 10 ? day : "0" + day
      }`;
    },
    // yyyy-MM-dd HH:mm:ss
    readDate: function (date) {
      try {
        //解决ios手机时间格式化NAN问题
        if (typeof (date) == "string" && date.indexOf('-') !== -1) {
          date = date.replace(/-/g, '/');
        }
        date = new Date(date);
      } catch (e) {
        console.error('date error', e)
      }
      return date
    }
    ,
    //获取两日期之间日期列表函数
    getDiffDateList(stime, etime) {
      //初始化日期列表，数组
      let diffdate = [];
      let i = 0;
      //开始日期小于等于结束日期,并循环
      while (stime <= etime) {
        diffdate[i] = stime;
        //获取开始日期时间戳
        let stime_ts = new Date(stime).getTime();
        //增加一天时间戳后的日期
        let next_date = stime_ts + 24 * 60 * 60 * 1000;
        //拼接年月日，这里的月份会返回（0-11），所以要+1
        let next_dates_y = new Date(next_date).getFullYear() + "-";
        let next_dates_m =
          new Date(next_date).getMonth() + 1 < 10
            ? "0" + (new Date(next_date).getMonth() + 1) + "-"
            : new Date(next_date).getMonth() + 1 + "-";
        let next_dates_d =
          new Date(next_date).getDate() < 10
            ? "0" + new Date(next_date).getDate()
            : new Date(next_date).getDate();
        stime = next_dates_y + next_dates_m + next_dates_d;
        //增加数组key
        i++;
      }
      return diffdate;
    },
    playAudio() {
      let audio = new Audio();
      audio.src = "/static/open.wav";
      audio.play();
    },
    formatMoney(money, currency, roundDown = false) {
      currency = currency || this.currency;
      money = this.dealMoney(money, currency, roundDown);
      // let moneyStr = dealMoney1.toString().replace(/\d(?=(?:\d{3})+\b)/g, currency === 'VND' || currency === '₫' ? '$&.' : '$&,');
      // return moneyStr + ' ' + currency;

      if (currency === 'VND' || currency === '₫') {
        //越南,金额没有小数
        money = money.toFixed(0).toString().replace(/\d(?=(?:\d{3})+\b)/g, '$&.')
        return money + ' ' + currency
      }
      if (currency === 'IDR' || currency === 'Rp') {
        money = money.toFixed(0).toString().replace(/\d(?=(?:\d{3})+\b)/g, '$&.')
        return currency + ' ' + money
      }
      const decimalNum = this.paramMapAll['SYSTEM_COUNTRY_CURRENCY_DECIMAL'] || 2
      money = money.toFixed(decimalNum).replace(/\d(?=(?:\d{3})+\b)/g, '$&,')
      return currency + (currency.length >= 3 ? ' ' : '') + money
    },
    //
    dealMoney(money, currency, roundDown) {
      money = parseFloat(money || 0);
      currency = currency || this.currency;
      let n = currency === 'VND' || currency === '₫' ? 0 : 2;
      if (roundDown) {
        // 保留n位小数,退1法
        const multiplier = Math.pow(10, n);
        money = Math.floor(money * multiplier) / multiplier;
      } else {
        // 保留n位小数,四舍五入
        money = parseFloat(money.toFixed(n));
      }
      return money
    },
    formatNumber(value, digitNumber = 0) {
      if (value == null) {
        value = 0;
      }
      return value
        .toFixed(digitNumber)
        .toString()
        .replace(/\d(?=(?:\d{3})+\b)/g, "$&,");
    },

    copy_txt(url) {
      const text = document.getElementById("webcopyinput");
      text.id = "webcopyinput";
      text.value = url;
      text.focus({preventScroll: true}); //给input输入框聚焦
      text.setSelectionRange(0, text.value.length); //设置input框选中的范围
      document.execCommand("copy"); //执行复制操作
      text.blur();
      this.$message.success(this.$t("Copy_Success"));
    },

    toLink(url) {
      url.indexOf("http") > -1
        ? (window.location.href = url)
        : router.push({path: url});
    },
    getTextarea(value) {
      return value && value.replace(/\n/g, "<br/>");
    },

    encryptAccount(account) {
      if (account && this.paramMapAll["ACCOUNT_INFO_ENCRYPT_OPEN"] === "1") {
        return account.replace(/^(.{3}).+(.{3})$/, "$1****$2");
      }
      return account;
    },

    download() {
      if (this.paramMapAll["APP_DOWNLOAD_PAGE"]) {
        window.open(this.paramMapAll["APP_DOWNLOAD_PAGE"], "_blank");
      } else {
        this.$router.push({path: `/m/app`});
      }
    },

    logout() {
      this.$dialog
        .confirm({
          title: this.$t("提示"),
          message: this.$t("确定登出吗"),
          confirmButtonText: this.$t("确定"),
          cancelButtonText: this.$t("取消")
        })
        .then(() => {
          this.$store.dispatch("user/logout").then(() => {
            // console.log('jump("/login")')
            // debugger
            this.jump("/login");
          });
        })
        .catch(() => {
        });
    },

    isLogin() {
      return isLogin();
    },

    async addToCart(item) {
      await this.$store.dispatch("user/addToCart", {
        shopId: item.shopId,
        goodsSpecId: item.goodsSpecId,
        goodsId: item.goodsId,
        number: item.number || 1
      });
      this.$toast.success(this.$t("项目添加到您的购物车"));
    },

    async removeFromCart(cartId) {
      await this.$store.dispatch("user/deleteFromCart", cartId);
    },

    gotToProduct(goodsId, shopId) {
      this.jump(this.productUrl(goodsId, shopId));
    },

    showItemAddedToCartDialog(spec, cateCode, goods) {
      this.$store.commit("common/SET_itemAddedToCartDialogInfo", {
        spec,
        cateCode,
        goods,
      });
    },

    productUrl(goodsId, shopId) {
      return `/product?goodsId=${goodsId}&shopId=${shopId}`;
    },

    categoryUrl({name, code}) {
      return `/category?cateName=${encodeURIComponent(this.$t(name))}&cateCode=${code}`;
    },

    isSingleSpec() {

    },

    isValidateSpec(name) {
      return (
        name && name !== "默认" && name !== "default" && name !== "Default"
      );
    },
    getFileViewContent(richTextContent) {
      if (!richTextContent) {
        return richTextContent
      }
      return richTextContent.replace(/src="file/g, 'src="' + fileServer + 'file')
    },
    getFileViewContent2(content) {
      if (!content) return content;

      // 去掉 {host}/ 或 {{host}}/
      content = content.replace(/{{?host}?}\//g, '');

      // 替换 src="file/..." 为 src="http://xxx/file/..."
      content = content.replace(/src="file\/([^"]+)"/g, `src="${fileServer}file/$1"`);

      // 替换 background-image:url('file/...')
      content = content.replace(/background-image:\s*url\(['"]?file\/(.*?)['"]?\)/g,
          `background-image:url('${fileServer}file/$1')`);

      return content;
    },
    deepEqual(obj1, obj2) {
      if (obj1 === obj2) {
        return true
      }

      if (typeof obj1 !== typeof obj2) {
        return false
      }

      if (typeof obj1 !== 'object' || obj1 === null || obj2 === null) {
        return obj1 === obj2
      }

      if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) {
          return false
        }

        for (let i = 0; i < obj1.length; i++) {
          if (!this.deepEqual(obj1[i], obj2[i])) {
            return false
          }
        }

        return true
      }

      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false
      }

      for (const key of Object.keys(obj1)) {
        if (!this.deepEqual(obj1[key], obj2[key])) {
          return false
        }
      }

      return true
    }
  }
};
export default mixin;
